angular.module('core')
    .directive('datepickerPopup', function (){
        // Borrowed from https://github.com/angular-ui/bootstrap/issues/2659#issuecomment-60750976
        //
        // There is an Angular bug, where the initial value shown in the datepicker input field
        // is not formatted; only after a date is picked does it become formatted as desired. This is
        // a workaround for that, so the date is always formatted as desired.
        return {
            restrict: 'EAC',
            require: 'ngModel',
            link: function(scope, element, attr, controller) {
                //remove the default formatter from the input directive to prevent conflict
                controller.$formatters.shift();
            }
        };
    });
